import { LocalizePositionService, MyLocationService } from '@addins/core/map';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SagaSettingsService } from '@services/settings';
import { from, Subscription, switchMap } from 'rxjs';
import { LocalizeButtonTool } from '../../public_api';
import { ButtonsProviderService } from '../../services/buttons-provider/buttons-provider.service';
import { CallcardDetailButtonsComponent } from '../callcard-detail-buttons/callcard-detail-buttons.component';

@Component({
  selector: 'app-callcard-detail-buttons-h',
  templateUrl: './callcard-detail-buttons-h.component.html',
  styleUrls: ['./callcard-detail-buttons-h.component.scss']
})
export class CallcardDetailButtonsHComponent extends CallcardDetailButtonsComponent implements OnInit, OnDestroy {
  buttonFontSize: string = null;

  private localizeCardButton: LocalizeButtonTool;
  private localizeCardSub: Subscription;
  private localizeCardAndMeButton: LocalizeButtonTool;
  private localizeCardAndMeSub: Subscription;

  constructor(
    protected buttonsProvider: ButtonsProviderService,
    private settingsService: SagaSettingsService,
    private localizePosition: LocalizePositionService,
    private myLocationService: MyLocationService
  ) {
    super(buttonsProvider);
  }

  ngOnInit() {
    this.buttonFontSize = this.settingsService.getValue('SagaMobileWebClient.SingleCallcard.FooterButtonsTextSize');

    this.localizeCardButton = new LocalizeButtonTool('LocalizeCard', 'pin', 700);
    this.localizeCardSub = this.localizeCardButton.onClick.subscribe(event => {
      event.coordinates = [event.target.location.coordinate];
      this.localizePosition.localize(event);
    });

    this.localizeCardAndMeButton = new LocalizeButtonTool('LocalizeCardAndMe', 'assets/icons/localize-icons/person-callcard.svg', 800);
    this.localizeCardAndMeSub = this.localizeCardAndMeButton.onClick
      .pipe(
        switchMap(event =>
          from(
            this.myLocationService.getCurrent().then(coordinate => {
              event.coordinates = [event.target.location.coordinate, coordinate];
              return event;
            })
          )
        )
      )
      .subscribe(event => this.localizePosition.localize(event));

    this.buttonsProvider.add(this.localizeCardButton);
    this.buttonsProvider.add(this.localizeCardAndMeButton);
  }

  ngOnDestroy() {
    this.localizeCardAndMeSub?.unsubscribe();
    this.localizeCardSub?.unsubscribe();

    this.buttonsProvider.remove(this.localizeCardAndMeButton);
    this.buttonsProvider.remove(this.localizeCardButton);
  }
}
